var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638502041363,
    className: "icon",
    viewBox: "0 0 1536 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 11660,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1536v1024H0z",
    fill: "#E94B35",
    "p-id": 11661
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304 496l-141.056 98.176 49.76-164.48-136.96-103.872 171.84-3.52L304 160l56.416 162.336 171.84 3.52-136.96 103.808 49.76 164.48zM567.232 216.064l-44.288 11.712 27.456-36.672-24.832-38.496 43.36 14.784 28.96-35.52-0.64 45.824 42.72 16.544-43.808 13.536-2.528 45.76zM716.8 339.04l-19.52 41.472-10.4-44.608-45.472-5.76 39.2-23.68L672 261.44l34.688 29.952 40.128-22.08-17.76 42.24 33.408 31.36zM699.552 508.32l-41.6 19.232 20.704-40.896-31.168-33.6 45.28 7.04 22.336-40 7.296 45.216 44.992 8.896-40.8 20.896 5.44 45.504zM567.232 632.064l-44.288 11.712 27.456-36.672-24.832-38.496 43.36 14.784 28.96-35.52-0.64 45.824 42.72 16.544-43.808 13.536-2.528 45.76z",
    fill: "#F2C500",
    "p-id": 11662
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.4d892f5a.svg";
export { ForwardRef as ReactComponent };